import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { PreregistrationAccount } from '@main-client/src/app/invite-csv/invite-csv-view/invite-csv-view.interface';

const GroupPreRegistrationApiUrl = (groupId: string) =>
  `/api/v2/groups/${groupId}/pre-registrations`;

@Injectable()
export class InviteMembersService {
  constructor(private http: HttpClient) {}

  inviteAccountToGroup(groupId: string, accountBody: any) {
    const url = GroupPreRegistrationApiUrl(groupId);
    return this.http.post(url, accountBody);
  }

  resendPlatformInvitation(
    groupId: string,
    preregistration: PreregistrationAccount,
  ) {
    const url = `${GroupPreRegistrationApiUrl(groupId)}/${
      preregistration._id
    }/resend-email`;
    return this.http.post(url, preregistration);
  }

  resendPendingPlatformInvitations(groupId: string, emails?: string[]) {
    const url = `${GroupPreRegistrationApiUrl(groupId)}/resend-pending-emails`;
    return this.http.post(url, { emails });
  }

  deletePlatformInvitation(
    groupId: string,
    preregistration: PreregistrationAccount,
  ) {
    const url = `${GroupPreRegistrationApiUrl(groupId)}/${preregistration._id}`;
    return this.http.delete(url);
  }

  deletePendingPlatformInvitations(groupId: string, emails: string[] = []) {
    const url = GroupPreRegistrationApiUrl(groupId);
    return this.http.delete(url, { params: { emails } });
  }
}
